import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  DxButtonModule,
  DxChartModule,
  DxDataGridModule,
  DxLoadIndicatorModule,
  DxPieChartModule,
  DxPopupModule,
  DxTextAreaModule,
} from 'devextreme-angular';
import { MarkdownModule } from 'ngx-markdown';

import { AgentChatComponent } from './agent-chat/agent-chat.component';
import { AiAgentsShellComponent } from './ai-agents-shell/ai-agents-shell.component';
import { SupportChatPopupComponent } from './support-chat-popup/support-chat-popup.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxButtonModule,
    DxChartModule,
    DxDataGridModule,
    DxLoadIndicatorModule,
    DxPieChartModule,
    DxPopupModule,
    DxTextAreaModule,
    MarkdownModule,
  ],
  declarations: [
    AgentChatComponent,
    AiAgentsShellComponent,
    SupportChatPopupComponent,
  ],
  exports: [
    AgentChatComponent,
    AiAgentsShellComponent,
    SupportChatPopupComponent,
  ],
})
export class AiAgentChatModule {}
